import { Phone, MessageCircle } from "lucide-react";
import { useSiteConfig } from "@/context/SiteConfigContext";
import { telHref, waHref } from "@/lib/links";
import { ApplyButton } from "@/components/site/AdmissionBadge";

export function MobileBottomNav() {
  const { config } = useSiteConfig();
  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-50 lg:hidden grid grid-cols-3 border-t border-amber-500/30"
      style={{ background: "rgba(10,30,78,0.98)", backdropFilter: "blur(12px)" }}
      data-testid="mobile-bottom-nav"
    >
      <a href={telHref(config.phonePrimary)} className="flex flex-col items-center justify-center gap-1 py-3 text-white" data-testid="mobile-nav-call-button">
        <Phone size={20} className="text-[#D4AF37]" />
        <span className="text-[11px] font-semibold uppercase tracking-wide">Call</span>
      </a>
      <a href={waHref(config.whatsapp)} target="_blank" rel="noopener noreferrer" className="flex flex-col items-center justify-center gap-1 py-3 text-white border-x border-white/10" data-testid="mobile-nav-whatsapp-button">
        <MessageCircle size={20} className="text-[#25D366]" />
        <span className="text-[11px] font-semibold uppercase tracking-wide">WhatsApp</span>
      </a>
      <ApplyButton
        className="flex flex-col items-center justify-center gap-1 py-3 text-white font-semibold"
        testId="mobile-nav-apply-button"
      >
        <span className="flex flex-col items-center gap-1">
          <span className="flex h-5 w-5 items-center justify-center rounded-full bg-[#C0202A] text-[11px]">→</span>
          <span className="text-[11px] font-semibold uppercase tracking-wide">Apply</span>
        </span>
      </ApplyButton>
    </div>
  );
}
